
import { Component, Vue, Prop } from "vue-property-decorator";
import Pagination from "@/components/paginaiton.vue";
import { getGanyuList, deleteGanyu } from "@/request/doctor";
@Component({
  components: {
    Pagination,
  },
})
export default class Name extends Vue {
  private filter: any = {
    current_page: 1,
    page_count: 10,
    totalCount: 0,
  };
  private list: any = [];
  private get user() {
    return this.$store.state.user || {};
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private goDetail(item: any) {
    this.$router.push({
      path: "/main/workstation/ganyu-detail",
      query: {
        intervene_id: item.intervene_id,
        type: "read",
      },
    });
  }
  /**
   * @description 处理页码变化
   */
  private handleCurrentPageChange(val: any) {
    this.filter.current_page = val;
    this.getList();
  }
  /**
   * @description 处理翻页器的每页条数变化
   */
  private handleCurrentSizeChange(val: any) {
    this.filter.current_page = 1;
    this.filter.page_count = val;
    this.getList();
  }
  private goAdd() {
    this.$router.push("/main/workstation/ganyu-edit");
  }
  private goEdit(item: any) {
    this.$router.push({
      path: "/main/workstation/ganyu-edit",
      query: {
        intervene_id: item.intervene_id,
      },
    });
  }
  private refresh() {
    this.filter.current_page = 1;
    this.getList();
  }
  private deleteGanyu(item: any) {
    const params = {
      data: {
        intervene_id: item.intervene_id,
      },
    };
    deleteGanyu(this, params).then((res: any) => {
      this.$message.success("删除成功！");
      this.getList();
    });
  }
  private getList() {
    const params = {
      patient_id: this.patient.patient_id,
      current_page: this.filter.current_page,
    };
    getGanyuList(this, params).then((res: any) => {
      this.list = res.intervenes;
      this.filter.totalCount = res.total_count;
    });
  }
  private mounted() {
    this.getList();
  }
}
